'use client';
import { _ as _extends, a as _object_without_properties_loose } from './cc-zJdVkWBV.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { XIcon } from 'lucide-react';
import { cn } from '@repo/lib/utils';

function Dialog(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DialogPrimitive.Root, _extends({
        "data-slot": "dialog"
    }, props));
}
function DialogTrigger(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DialogPrimitive.Trigger, _extends({
        "data-slot": "dialog-trigger"
    }, props));
}
function DialogPortal(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DialogPrimitive.Portal, _extends({
        "data-slot": "dialog-portal"
    }, props));
}
function DialogClose(_0) {
    let props = _extends({}, _0);
    return /*#__PURE__*/ jsx(DialogPrimitive.Close, _extends({
        "data-slot": "dialog-close"
    }, props));
}
function DialogOverlay(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(DialogPrimitive.Overlay, _extends({
        "data-slot": "dialog-overlay",
        className: cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50", className)
    }, props));
}
function DialogContent(_0) {
    let { className, children, showCloseButton = true } = _0, props = _object_without_properties_loose(_0, [
        "className",
        "children",
        "showCloseButton"
    ]);
    return /*#__PURE__*/ jsxs(DialogPortal, {
        "data-slot": "dialog-portal",
        children: [
            /*#__PURE__*/ jsx(DialogOverlay, {}),
            /*#__PURE__*/ jsxs(DialogPrimitive.Content, _extends({
                "data-slot": "dialog-content",
                className: cn("bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg", className)
            }, props, {
                children: [
                    children,
                    showCloseButton && /*#__PURE__*/ jsxs(DialogPrimitive.Close, {
                        "data-slot": "dialog-close",
                        className: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
                        children: [
                            /*#__PURE__*/ jsx(XIcon, {}),
                            /*#__PURE__*/ jsx("span", {
                                className: "sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            }))
        ]
    });
}
function DialogHeader(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx("div", _extends({
        "data-slot": "dialog-header",
        className: cn("flex flex-col gap-2 text-center sm:text-left", className)
    }, props));
}
function DialogFooter(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx("div", _extends({
        "data-slot": "dialog-footer",
        className: cn("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", className)
    }, props));
}
function DialogTitle(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(DialogPrimitive.Title, _extends({
        "data-slot": "dialog-title",
        className: cn("text-lg leading-none font-semibold", className)
    }, props));
}
function DialogDescription(_0) {
    let { className } = _0, props = _object_without_properties_loose(_0, [
        "className"
    ]);
    return /*#__PURE__*/ jsx(DialogPrimitive.Description, _extends({
        "data-slot": "dialog-description",
        className: cn("text-muted-foreground text-sm", className)
    }, props));
}

export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
